module.exports = __webpack_public_path__ + "static/media/calculadora.58251f43.png";